module.exports = __webpack_public_path__ + "static/media/5-1.02e245f4.mp3";